import { AxiosInstance } from 'axios';
import { httpService } from './initHttpService';

type ServiceConstructor<T> = new (http: AxiosInstance) => T;

export default <T>(Service: ServiceConstructor<T>): T => new Service(httpService);
